import { render } from "./nft-creators.vue?vue&type=template&id=1b3cd5fd"
import script from "./nft-creators.vue?vue&type=script&lang=js"
export * from "./nft-creators.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__